import {FC, useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "toolkit/hooks";
import StepInfo from "pages/StepPages/components";
import {ReactComponent as LackObjectList} from "images/LackObjectList.svg";
import {Button} from "components/shared";
import {ModalWindow} from "components/ModalWindow/ModalWindow";
import {AddingObjectList} from "./AddingObjectList/AddingObjectList";
import {ObjectListTable} from "./ObjectListTable/ObjectListTable";
import {StepThreeMenu} from "./StepThreeMenu/StepThreeMenu";
import {useParams} from "react-router-dom";
import {getAllEnumList, getMainEnumList} from "toolkit/steps/stepThree/stepThree.thunk";
import {EnumListFiltration} from "./EnumListFiltration/EnumListFiltration";
import Badge from "components-new/Badge";
import {convertDate} from "helpers";
import styles from "./ObjectList.module.sass";
import cn from "classnames";
import {resetStep_3} from "toolkit/steps/stepThree/stepThree.slice";

export const ObjectList: FC = () => {
	// const selectedOrganization = useAppSelector(state => state.organizations.selectedOrganization);
	const [modalWindow, setModalWindow] = useState<boolean>(false);
	const { organizationId } = useParams();
	const { mainEnumList, currentEnumList } = useAppSelector((state) => state.stepThree);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!organizationId) return;
		dispatch(getMainEnumList(+organizationId));
		//eslint-disable-next-line
	}, []);

	// useEffect(() => {
	// 	if (!organizationId) return;
	// 	if (id !== +organizationId) {
	// 		dispatch(ChangeId(+organizationId));
	// 	}
	// }, [organizationId]);

	useEffect(() => {
		if (mainEnumList && organizationId) dispatch(getAllEnumList(+organizationId));
		//eslint-disable-next-line
	}, [mainEnumList]);

	useEffect(() => {
		return () => {
			dispatch(resetStep_3());
		};
		//eslint-disable-next-line
	}, []);

	const writeEnumListName = (): string => {
		// const currentEnumList = allEnumList.filter(enumList => enumList.id === currentEnumListId)[0];
		if (!currentEnumList) return "";
		return `${currentEnumList?.type === 1 ? "Перечень" : "Дополнение в перечень"} “${
			currentEnumList?.listName
		}” от ${convertDate(currentEnumList.creationDate)}`;
	};

	return (
		<>
			{modalWindow && (
				<ModalWindow close={() => setModalWindow(false)} scroll={false}>
					<AddingObjectList
						title="Создание перечня"
						subtitle="Выберите элементы для создания перечня"
						close={() => setModalWindow(false)}
						mode="main"
					/>
				</ModalWindow>
			)}
			<main className={styles.content}>
				<section className={cn(styles.categorization, !mainEnumList && styles.full)}>
					<div className={styles.header}>
						<div className={styles["stepInfo-wrp"]}>
							<StepInfo
								stepTitle={"3. Формирование перечня ОКИИ"}
								info="Перечень объектов критической информационной инфраструктуры"
								companyName={`${!mainEnumList ? "Перечень отсутствует" : writeEnumListName()}${
									currentEnumList?.newestDocApprovalDate
										? `, загрузил утвержденную версию: ${currentEnumList.uploaderName}`
										: ""
								}`}
							/>
							{currentEnumList && (
								<div className={styles["badge-wrp"]}>
									{currentEnumList?.newestDocApprovalDate ? (
										<Badge type="success">Утверждён {convertDate(currentEnumList?.newestDocApprovalDate)}</Badge>
									) : (
										<Badge type="error">Не утверждён</Badge>
									)}
								</div>
							)}
						</div>
						<div className={styles["header-item"]}>
							{mainEnumList ? (
								<>
									<EnumListFiltration />
									<StepThreeMenu />
								</>
							) : (
								<Button onClick={() => setModalWindow(true)} className={styles.button}>
									Создать перечень
								</Button>
							)}
						</div>
					</div>
					{mainEnumList ? (
						<ObjectListTable />
					) : (
						<div data-comment-false={true} className={styles["warning-wrp"]}>
							<div className={styles.warning}>
								<LackObjectList />
								<span className={styles["warning-title"]}>У данной организации пока нет перечня</span>
							</div>
						</div>
					)}
				</section>
			</main>
		</>
	);
};
